// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const FlexContract = contract({
  name: "Flex",
  description: "The unopinionated flexbox primitive — reach for Flex when Stack, Row, or Grid don't quite fit. Specifically when you need reverse direction (`row-reverse` / `col-reverse`), CSS defaults instead of Row's baked-in `items-center gap-md`, or baseline alignment. Otherwise prefer Stack / Row / Grid — they're easier to read and tuned for the 95% case. Flex is the escape hatch, not the default.",
  import: "@gradeui/ui",
  aliases: ["flex","flexbox","flex container","hstack","vstack","horizontal","vertical","generic container","layout view"],
  composesWith: ["any content component"],
  props: {
  "direction": {
      schema: z.enum(["row", "col", "row-reverse", "col-reverse"]).optional(),
      design: "knob",
      description: "main-axis direction",
      default: "row",
  },
  "gap": {
      schema: z.enum(["none", "xs", "sm", "md", "lg", "xl", "2xl"]).optional(),
      design: "knob",
      description: "gap between children",
      default: "none",
  },
  "align": {
      schema: z.enum(["start", "center", "end", "stretch", "baseline"]).optional(),
      design: "knob",
      description: "cross-axis alignment",
      default: "stretch",
  },
  "justify": {
      schema: z.enum(["start", "center", "end", "between", "around", "evenly"]).optional(),
      design: "knob",
      description: "main-axis distribution",
      default: "start",
  },
  "wrap": {
      schema: z.enum(["nowrap", "wrap", "wrap-reverse"]).optional(),
      design: "knob",
      description: "wrap behaviour when children overflow",
      default: "nowrap",
  },
  "asChild": {
      schema: z.boolean().optional(),
      design: "plumbing",
      description: "render as the child element via Slot",
      default: false,
  },
  "className": {
      schema: z.string().optional(),
      design: "plumbing",
  },
  "children": {
      schema: z.unknown(),
      design: "plumbing",
  },
  },
});
